/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
/** @jsxImportSource solid-js */

import { customElement } from 'solid-element';
import LimitVisibleItems, { LimitVisibleItemsProps } from './LimitVisibleItems';

// TypeScript declaration for the web component
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tc-limit-visible-items': Partial<HTMLElement> &
        LimitVisibleItemsProps &
        Partial<{ ref: any }>;
    }
  }
}

export function defineSolidLimitVisibleItems(): void {
  customElement(
    'tc-limit-visible-items',
    {
      itemLimit: 5,
      className: undefined,
      showMore: undefined,
      showLess: undefined,
      content: undefined,
    },
    LimitVisibleItems
  );
}
